import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchEenVideoMutationVariables = Types.Exact<{
  input: Types.EenVideoSearchInput;
}>;


export type SearchEenVideoMutation = { __typename?: 'mutation_root', een_video_search?: { __typename?: 'EenVideoSearchOutput', data: string } | null };


export const SearchEenVideoDocument = gql`
    mutation searchEenVideo($input: EenVideoSearchInput!) {
  een_video_search(input: $input) {
    data
  }
}
    `;
export type SearchEenVideoMutationFn = Apollo.MutationFunction<SearchEenVideoMutation, SearchEenVideoMutationVariables>;

/**
 * __useSearchEenVideoMutation__
 *
 * To run a mutation, you first call `useSearchEenVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSearchEenVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [searchEenVideoMutation, { data, loading, error }] = useSearchEenVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchEenVideoMutation(baseOptions?: Apollo.MutationHookOptions<SearchEenVideoMutation, SearchEenVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SearchEenVideoMutation, SearchEenVideoMutationVariables>(SearchEenVideoDocument, options);
      }
export type SearchEenVideoMutationHookResult = ReturnType<typeof useSearchEenVideoMutation>;
export type SearchEenVideoMutationResult = Apollo.MutationResult<SearchEenVideoMutation>;
export type SearchEenVideoMutationOptions = Apollo.BaseMutationOptions<SearchEenVideoMutation, SearchEenVideoMutationVariables>;